import { hermioneMediaArray } from './hermioneMedia'
import { hermioneBio } from './hermioneBios'
import { ronProfileReviewHinge, dumbledoreProfileReviewBumble, harryProfileReviewTinder } from './hermioneProfileReviews'

export const hermioneDatingProfileHinge = {
  _id: 'hermioneDatingProfileHingeId',
  userId: 'hermioneUserId',
  email: 'hermione@email.com',
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: hermioneMediaArray[3]._id,
      mediaItemURL: hermioneMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[3].type,
      caption: hermioneMediaArray[3].captions[1],
      subcaption: hermioneMediaArray[3].subcaptions[2],
    },
    {
      mediaItemId: hermioneMediaArray[1]._id,
      mediaItemURL: hermioneMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[1].type,
      caption: hermioneMediaArray[1].captions[1],
      subcaption: hermioneMediaArray[1].subcaptions[1],
    },
    {
      mediaItemId: hermioneMediaArray[5]._id,
      mediaItemURL: hermioneMediaArray[5].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[5].type,
      caption: hermioneMediaArray[5].captions[0],
      subcaption: hermioneMediaArray[5].subcaptions[2],
    },
    {
      mediaItemId: hermioneMediaArray[13]._id,
      mediaItemURL: hermioneMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[13].type,
      caption: hermioneMediaArray[13].captions[2],
      subcaption: hermioneMediaArray[13].subcaptions[2],
    },
    {
      mediaItemId: hermioneMediaArray[9]._id,
      mediaItemURL: hermioneMediaArray[9].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[9].type,
      caption: hermioneMediaArray[9].captions[2],
      subcaption: hermioneMediaArray[9].subcaptions[2],
    },
    {
      mediaItemId: hermioneMediaArray[2]._id,
      mediaItemURL: hermioneMediaArray[2].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[2].type,
      caption: hermioneMediaArray[2].captions[2],
      subcaption: hermioneMediaArray[2].subcaptions[1],
    }
  ],
  bio: {
    bioItemsId: hermioneBio._id,
    vitalInfo: { ...hermioneBio.vitalInfo },
    prompts: [
      { ...hermioneBio.prompts[0] },
      { ...hermioneBio.prompts[1] },
      { ...hermioneBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: ['', '', '', '', ''],
  },
  profileReviews: [
    { ...ronProfileReviewHinge }
  ],
  mediaItems: [ ...hermioneMediaArray ],
  bioItems: { ...hermioneBio },
}

export const hermioneDatingProfileBumble = {
  _id: 'hermioneDatingProfileBumbleId',
  userId: 'hermioneUserId',
  email: 'hermione@email.com',
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: hermioneMediaArray[3]._id,
      mediaItemURL: hermioneMediaArray[3].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[3].type,
      caption: hermioneMediaArray[3].captions[1],
      subcaption: hermioneMediaArray[3].subcaptions[2],
    },
    {
      mediaItemId: hermioneMediaArray[1]._id,
      mediaItemURL: hermioneMediaArray[1].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[1].type,
      caption: hermioneMediaArray[1].captions[1],
      subcaption: hermioneMediaArray[1].subcaptions[1],
    },
    {
      mediaItemId: hermioneMediaArray[5]._id,
      mediaItemURL: hermioneMediaArray[5].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[5].type,
      caption: hermioneMediaArray[5].captions[0],
      subcaption: hermioneMediaArray[5].subcaptions[2],
    },
    {
      mediaItemId: hermioneMediaArray[13]._id,
      mediaItemURL: hermioneMediaArray[13].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[13].type,
      caption: hermioneMediaArray[13].captions[2],
      subcaption: hermioneMediaArray[13].subcaptions[2],
    },
    {
      mediaItemId: hermioneMediaArray[9]._id,
      mediaItemURL: hermioneMediaArray[9].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[9].type,
      caption: hermioneMediaArray[9].captions[2],
      subcaption: hermioneMediaArray[9].subcaptions[2],
    },
    {
      mediaItemId: hermioneMediaArray[2]._id,
      mediaItemURL: hermioneMediaArray[2].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[2].type,
      caption: hermioneMediaArray[2].captions[2],
      subcaption: hermioneMediaArray[2].subcaptions[1],
    }
  ],
  bio: {
    bioItemsId: hermioneBio._id,
    vitalInfo: { ...hermioneBio.vitalInfo },
    prompts: [
      { ...hermioneBio.prompts[0] },
      { ...hermioneBio.prompts[1] },
      { ...hermioneBio.prompts[2] }
    ],
    aboutMe: hermioneBio.aboutMe[0],
    hobbies: [hermioneBio.hobbies[0], hermioneBio.hobbies[1], hermioneBio.hobbies[2], hermioneBio.hobbies[3], hermioneBio.hobbies[4] ],
  },
  profileReviews: [
    { ...dumbledoreProfileReviewBumble }
  ],
  mediaItems: [ ...hermioneMediaArray ],
  bioItems: { ...hermioneBio },
}

export const hermioneDatingProfileTinder = {
  _id: 'hermioneDatingProfileTinderId',
  userId: 'hermioneUserId',
  email: 'hermione@email.com',
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: hermioneMediaArray[3]._id,
      mediaItemURL: hermioneMediaArray[3].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[3].type,
      caption: hermioneMediaArray[3].captions[1],
      subcaption: hermioneMediaArray[3].subcaptions[2],
    },
    {
      mediaItemId: hermioneMediaArray[1]._id,
      mediaItemURL: hermioneMediaArray[1].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[1].type,
      caption: hermioneMediaArray[1].captions[1],
      subcaption: hermioneMediaArray[1].subcaptions[1],
    },
    {
      mediaItemId: hermioneMediaArray[5]._id,
      mediaItemURL: hermioneMediaArray[5].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[5].type,
      caption: hermioneMediaArray[5].captions[0],
      subcaption: hermioneMediaArray[5].subcaptions[2],
    },
    {
      mediaItemId: hermioneMediaArray[13]._id,
      mediaItemURL: hermioneMediaArray[13].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[13].type,
      caption: hermioneMediaArray[13].captions[2],
      subcaption: hermioneMediaArray[13].subcaptions[2],
    },
    {
      mediaItemId: hermioneMediaArray[9]._id,
      mediaItemURL: hermioneMediaArray[9].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[9].type,
      caption: hermioneMediaArray[9].captions[2],
      subcaption: hermioneMediaArray[9].subcaptions[2],
    },
    {
      mediaItemId: hermioneMediaArray[2]._id,
      mediaItemURL: hermioneMediaArray[2].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[2].type,
      caption: hermioneMediaArray[2].captions[2],
      subcaption: hermioneMediaArray[2].subcaptions[1],
    }
  ],
  bio: {
    bioItemsId: hermioneBio._id,
    vitalInfo: { ...hermioneBio.vitalInfo },
    prompts: [
      { ...hermioneBio.prompts[0] },
      { ...hermioneBio.prompts[1] },
      { ...hermioneBio.prompts[2] }
    ],
    aboutMe: hermioneBio.aboutMe[0],
    hobbies: [hermioneBio.hobbies[0], hermioneBio.hobbies[1], hermioneBio.hobbies[2], hermioneBio.hobbies[3], hermioneBio.hobbies[4] ],
  },
  profileReviews: [
    { ...harryProfileReviewTinder }
  ],
  mediaItems: [ ...hermioneMediaArray ],
  bioItems: { ...hermioneBio },
}